import { apiSesionRecuperarContrasenia } from "../API";
import { IApiResult } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

export function _SvSesionRecuperarContrasenia(email: string, callback: (resStatus: number) => void) {
    let params = {
        Correo: email
    };

    new RequestData<IApiResult<any>>(apiSesionRecuperarContrasenia)
        .Params(params)
        .Completion((response, error) => {
            let status = response ? response.Resultado : -111;
            if (error)
                console.log(error.name, error.message);

            if (callback) callback(status);
        }).Post();
}
